



















































































































































































































































































































import Vue, { PropType } from 'vue';
// import { BoothData } from '@/modules/exhibitor/booth';
// import { Item } from '@/modules/exhibitor/item';
import {
  Item,
  BoothData,
  Option,
  options,
} from 'mostra';

interface DataType {
  categoryOptions: object[];
  // selectedTemplateTitle: string;
  boothDesignTypes: Option;
  designDisplayTypes: Option;
  titleFontOptions: Option;
  bodyFontOptions: Option;
  contactButtonShapeOptions: Option;
  isSelectModalOpen: boolean;
  itemOptions: Item[];
  selectedItemIds: string[];
  maxImageIndex: number;
  currentIndex: number;
  listLength: number;
  maxDisplayedItemLength: number;
  pagerLength: number;
  maxPagerLength: number;
  listItems: Item[];
  pagerItems: number[];
  displayMainImageSizeText: string;
}

export default Vue.extend({
  name: 'GBoothDesignForm',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    booth: {
      type: Object as PropType<BoothData>,
      required: true,
    },
    items: {
      type: Array as PropType<Item[]>,
      required: true,
    },
    onClickTemplateReset: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  data(): DataType {
    return {
      categoryOptions: [
        { text: '全てのカテゴリ', value: 0 },
        ...options.itemCategories,
      ],
      // selectedTemplateTitle: '',
      boothDesignTypes: options.boothDesignTypes,
      designDisplayTypes: options.designDisplayTypes,
      titleFontOptions: options.titleFontOptions,
      bodyFontOptions: options.bodyFontOptions,
      contactButtonShapeOptions: options.contactButtonShapeOptions,
      isSelectModalOpen: false,
      itemOptions: [],
      selectedItemIds: [],
      maxImageIndex: 4,
      currentIndex: 1,
      listLength: 0,
      maxDisplayedItemLength: 30,
      pagerLength: 0,
      maxPagerLength: 8,
      listItems: [],
      pagerItems: [],
      displayMainImageSizeText: '16：9',
    };
  },
  watch: {
    // 'booth.template.id'() {
    //   // this.setSelectedTemplateTitle();
    // },
    'booth.items'() {
      this.setItemOptions();
    },
    'booth.design.display.displayType'() {
      this.setMainImageSizeCaution();
    },
    itemOptions(array: any) {
      if (array) {
        this.listLength = array.length;
        this.pagerLength = Math.ceil(
          array.length / this.maxDisplayedItemLength,
        );
        this.createList(this.currentIndex);
      }
    },
    currentIndex(index: number) {
      this.createList(index);
    },
  },
  methods: {
    // setSelectedTemplateTitle() {
    //   const selectedTemplateId = this.booth.template.id;
    //   const selectedTemplate = options.templateOptions.find(
    //     (template) => selectedTemplateId === template.value,
    //   );
    //   if (selectedTemplate) {
    //     this.selectedTemplateTitle = selectedTemplate.text;
    //     return;
    //   }
    //   this.selectedTemplateTitle = '';
    // },
    setMainImageSizeCaution() {
      const selectedDisplayType = this.booth.design.display.displayType;
      switch (selectedDisplayType) {
        case 1:
          this.displayMainImageSizeText = '16：9';
          break;
        case 2:
          this.displayMainImageSizeText = '13：9';
          break;
        case 3:
          this.displayMainImageSizeText = '13：9';
          break;
        case 4:
          this.displayMainImageSizeText = '2：1';
          break;
        default:
          this.displayMainImageSizeText = '16:9';
      }
    },
    onChangeTitleFont(val: number) {
      this.booth.design.title.font = val;
    },
    onChangeBodyFont(val: number) {
      this.booth.design.body.font = val;
    },
    onChangeContactButtonShape(val: number) {
      this.booth.design.contact.shape = val;
    },
    onChangeLayout(val: number) {
      this.booth.design.layout = val;
    },
    onChangeDisplay(val: number) {
      this.booth.design.display.displayType = val;
    },
    setItemOptions() {
      const selectedItemIds = this.booth.items;
      this.itemOptions = this.items.filter(({ id }) => {
        if (!id) return false;
        return selectedItemIds.includes(id);
      });
      this.listItems = this.itemOptions;
    },
    onSelectItemImageStart() {
      this.onOpenSelectModal();
    },
    onDeleteItemImage(targetIndex: number) {
      return () => {
        this.booth.design.display.itemIds.splice(targetIndex, 1);
      };
    },
    onSwapItemImagePosition(mode: 'up' | 'down', targetIndex: number) {
      return () => {
        let swapTargetIndex = 0;
        if (mode === 'up') {
          if (targetIndex === 0) return;
          swapTargetIndex = targetIndex - 1;
        }
        if (mode === 'down') {
          if (this.booth.design.display.itemIds.length === targetIndex + 1) return;
          swapTargetIndex = targetIndex + 1;
        }
        const copieditemIds = [...this.booth.design.display.itemIds];
        copieditemIds[swapTargetIndex] = this.booth.design.display.itemIds[
          targetIndex
        ];
        copieditemIds[targetIndex] = this.booth.design.display.itemIds[
          swapTargetIndex
        ];
        this.booth.design.display.itemIds = copieditemIds;
      };
    },
    onCategoryChange(val: number) {
      const selectedItemIds = this.booth.items;
      if (!val) {
        this.itemOptions = this.items.filter(
          ({ id }) => id && selectedItemIds.includes(id),
        );
      } else {
        const selectedItems = this.items.filter(
          ({ id }) => id && selectedItemIds.includes(id),
        );
        this.itemOptions = selectedItems.filter(
          (itemValue: Item) => val === itemValue.data.category.categoryId,
        );
      }
      this.listItems = this.itemOptions;
      this.currentIndex = 1;
    },
    onSelectItemImageDone() {
      this.booth.design.display.itemIds = this.selectedItemIds;
      this.onCloseSelectModal();
    },
    onOpenSelectModal() {
      this.selectedItemIds = [...this.booth.design.display.itemIds];
      this.isSelectModalOpen = true;
    },
    onCloseSelectModal() {
      this.isSelectModalOpen = false;
    },
    createList(index: number) {
      const startIndex = (index - 1) * this.maxDisplayedItemLength;
      this.listItems = [];
      for (let i = 0; i < this.maxDisplayedItemLength; i++) {
        if (!this.itemOptions[startIndex + i]) break;
        this.listItems.push(this.itemOptions[startIndex + i]);
      }
    },
    setPagerItems(list: number[]) {
      this.pagerItems = list;
    },
    prevPage() {
      if (this.currentIndex <= 1) return;
      this.currentIndex--;
    },
    changePage(index: number) {
      this.currentIndex = index;
    },
    nextPage() {
      if (this.currentIndex >= this.pagerLength) return;
      this.currentIndex++;
    },
  },
  mounted() {
    // this.setSelectedTemplateTitle();
    this.setItemOptions();
    this.setMainImageSizeCaution();
  },
});
